const routes = [
    {
    path: '/release-notes',
    name: 'release-notes',
    component: () => import('source/pages/ReleaseNotesPage.vue'),
    meta: {
        title: 'HQZen - Release Notes',
        loginRequired: false
    },
}, {
    path: '/release-notes/note-details/:note_details_id',
    name: 'note-details',
    component: () => import('source/pages/release-notes/ReleaseNoteDetailsPage.vue'),
    meta: {
        title: 'HQZen - Release Note Details',
        canDisplayGlobalModals: true,
    },
},
];

export default routes;
